import {FC, HTMLAttributes} from 'react'

export const PlayIcon: FC<{width?: number; height?: number} & HTMLAttributes<SVGSVGElement>> = ({
    width = 14,
    height = 18,
    ...rest
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 18" fill="none" {...rest}>
            <path
                d="M1.16667 3.1576C1.16667 2.3483 1.16667 1.94365 1.33541 1.72059C1.48242 1.52626 1.70711 1.40601 1.95034 1.39149C2.22953 1.37482 2.56623 1.59928 3.23961 2.0482L12.0026 7.89018C12.559 8.26111 12.8372 8.44658 12.9341 8.68035C13.0189 8.88473 13.0189 9.11443 12.9341 9.3188C12.8372 9.55257 12.559 9.73804 12.0026 10.109L3.2396 15.951C2.56622 16.3999 2.22953 16.6243 1.95034 16.6077C1.70711 16.5931 1.48242 16.4729 1.33541 16.2786C1.16667 16.0555 1.16667 15.6509 1.16667 14.8416V3.1576Z"
                stroke="#000000"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
